import React, { Suspense } from 'react';
import MyVisitsHeader from '../components/me/visits/MyVisitHeader';
import MyVisitsList from '../components/me/visits/MyVisitsList';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageContainer from '../components/shared/page/PageContainer';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import VisitsPagination from '../components/visits/VisitsPagination';

const Home = () => {
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Мій кабінет'} />
        </PageTitleContainer>
        <PageContainer>
          <Container>
            <MyVisitsHeader />
            <MyVisitsList />
            <VisitsPagination />
          </Container>
        </PageContainer>
      </section>
    </Suspense>
  );
};

export default Home;
